import { getActiveCamera, renderer, scene } from "../viewer/scene";
import { updateFragmentsView } from "../fragments/engine";
import { state } from "../state";
import { setStatus } from "../ui/status";

function timestampSuffix(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

export async function takeCanvasScreenshot(): Promise<void> {
  if (!state.ifcModel) {
    setStatus("Загрузите IFC, чтобы сделать снимок.", true);
    return;
  }
  try {
    await updateFragmentsView(true);
    renderer.render(scene, getActiveCamera());
    renderer.domElement.toBlob((blob) => {
      if (!blob) {
        setStatus("Не удалось сохранить снимок canvas.", true);
        return;
      }
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `ifc-viewer-${timestampSuffix()}.png`;
      link.click();
      URL.revokeObjectURL(url);
      setStatus("Снимок canvas сохранён.");
    }, "image/png");
  } catch (error) {
    const message = error instanceof Error ? error.message : "Неизвестная ошибка";
    setStatus(`Снимок canvas: ${message}`, true);
  }
}
